<template>
  <div :class="$style.wrapper">
    <ul v-if="links.length > 0" :class="$style.list">
      <li v-for="link in links" :key="link.title">
        <a :href="link.link" @click="onClick(link)">#{{ link.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { createClient } from 'microcms-js-sdk';
import { onMounted, ref } from 'vue';

const props = defineProps<{
  apiKey: string;
}>();

interface Link {
  title: string;
  link: string;
}
const links = ref<Link[]>([]);

const microCms = createClient({
  serviceDomain: 'iichi',
  apiKey: props.apiKey,
});

const onClick = (link: Link) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'click_recommendation_link',
      recommend_link: link.link,
      recommend_title: link.title,
    });
  }
};

onMounted(async () => {
  try {
    const response = await microCms.getList<Link>({
      endpoint: 'recommendation-links',
    });
    links.value = response.contents;
  } catch (error) {
    window.Sentry?.captureException(error);
  }
});
</script>

<style module lang="scss">
.wrapper {
  @media (--pc) {
    margin: 6px 0 0;
    min-height: 21px;
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;

  @media (--pc) {
    font-size: 12px;
  }

  @media (--sp) {
    padding: 4px 0;
  }

  li a:hover {
    text-decoration: underline;
  }
}
</style>
